import { avatarData } from '../data/avatarData';

let emptyState = {};

avatarData.forEach(avatar => {
  let values = [];
  avatar.options.forEach(option => values[option.id] = null);
  emptyState[avatar.prefix] = values;
});
emptyState['currentAvatar'] = avatarData[0].prefix;

export default function avatar( state = emptyState, action ) {
  switch ( action.type ) {
    case 'SET_AVATAR':
      return {
        ...state,
        currentAvatar: action.currentAvatar,
      };
    case 'SET_ATTRIBUTE':
      return {
        ...state,
        [action.avatarKey]: {
          ...state[action.avatarKey],
          [action.valueKey]: action.value,
        },
      };
    case 'CLEAR_ATTRIBUTES':
      return emptyState;
    default:
      return state;
  }
}
